import { PipelineFunnel } from '../components/dashboard/PipelineFunnel';
import { MissionsPanel } from '../components/dashboard/MissionsPanel';
import { AgentsPanel } from '../components/dashboard/AgentsPanel';
import { OpsLogPanel } from '../components/dashboard/OpsLogPanel';
import { ObjectivesPanel } from '../components/dashboard/ObjectivesPanel';
import { ChannelsPanel } from '../components/dashboard/ChannelsPanel';
import { SourcesPanel } from '../components/dashboard/SourcesPanel';

export function Dashboard() {
  return (
    <div class="page">
      <PipelineFunnel />
      <div class="grid-3col">
        <div class="col-left">
          <MissionsPanel />
          <AgentsPanel />
        </div>
        <div>
          <OpsLogPanel />
        </div>
        <div class="col-right">
          <ObjectivesPanel />
          <ChannelsPanel />
          <SourcesPanel />
        </div>
      </div>
    </div>
  );
}
